import * as ActionTypes from '../ActionTypes';

const initialState = {
    eacUsersLoading: false,
    eacUserData: [],
   
};

export const EACUsersReducer = (state = initialState, action) => {
    switch (action.type) {  
        case ActionTypes.GET_EAC_USER_REQUEST:
            return {
                ...state,
                eacUsersLoading: true,
                eacUserData: [],
            }
        case ActionTypes.ADD_EAC_USER_REQUEST:
        case ActionTypes.UPDATE_EAC_USER_REQUEST:
            return {
                ...state,
                eacUsersLoading: true,
            };
        case ActionTypes.GET_EAC_USER_SUCCESS:
             return {
                ...state,
                eacUsersLoading: false,
                eacUserData: action.payload?.data?.data,
            };
        case ActionTypes.ADD_EAC_USER_SUCCESS:
        case ActionTypes.UPDATE_EAC_USER_SUCCESS:
            return {
                ...state,
                eacUsersLoading: false,
                // eacUserData: action.payload?.data?.data,
            };
        case ActionTypes.GET_EAC_USER_ERROR:
        case ActionTypes.ADD_EAC_USER_ERROR:
        case ActionTypes.UPDATE_EAC_USER_ERROR:
            return {
                ...state,
                eacUsersLoading: false,
            };
        default:
            return state;
    }
};
